import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

export default function FAQ() {
  const { t } = useLanguage();
  const items = t("faq.items");

  return (
    <section id="faq" data-testid="faq-section" className="relative bg-[#EADCCF] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
          <span className="text-[12px] uppercase tracking-[0.22em] text-[#C05A3A] font-medium inline-flex items-center gap-2">
            <HelpCircle className="h-4 w-4" strokeWidth={1.5} />
            {t("faq.eyebrow")}
          </span>
          <h2
            data-testid="faq-title"
            className="font-serif-display text-[#232321] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] mt-4"
          >
            {t("faq.title")}
          </h2>
          <p className="mt-5 text-[#5C5C59] text-base leading-relaxed max-w-sm">
            {t("faq.subtitle")}
          </p>
          <a
            href="tel:+12059837363"
            data-testid="faq-call-link"
            className="mt-6 inline-flex items-center gap-2 text-[#C05A3A] hover:text-[#A54C30] text-sm font-medium border-b border-[#C05A3A]/30 pb-1"
          >
            {t("faq.callUs")} (205) 983-7363
          </a>
        </div>

        <div className="lg:col-span-8">
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            className="space-y-3"
            data-testid="faq-accordion"
          >
            {items.map((it, idx) => (
              <AccordionItem
                key={it.q}
                value={`item-${idx}`}
                data-testid={`faq-item-${idx}`}
                className="border border-[#E2D9CD] bg-[#F9F6F0] rounded-2xl px-6 overflow-hidden data-[state=open]:bg-[#F9F6F0]"
              >
                <AccordionTrigger className="font-serif-display text-left text-xl md:text-2xl text-[#232321] hover:no-underline py-5">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5C5C59] text-base leading-relaxed pb-6 pr-2">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
